import axios from 'axios'
import { woTermCategoryUrl, getHeader } from '@/config'

const state = {
  woTermCategoryList: []
}

const mutations = {
  SET_WORK_ORDER_TERM_CATEGORY_LIST (state, obj) {
    state.woTermCategoryList = obj
  }
}

const actions = {
  getWoTermCategoryList: ({ commit }) => {
    axios.get(woTermCategoryUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_WORK_ORDER_TERM_CATEGORY_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
